import React, { FormEvent, useContext, useState, useEffect} from "react";
import EmployeeProfileStore from "../../../app/stores/employeeProfileStore";
import { observer } from "mobx-react-lite";
import { Button, Form, Segment } from "semantic-ui-react";
import { IEmployee } from "../../../app/models/employee";
import { RouteComponentProps } from "react-router";


interface PropsInterface extends RouteComponentProps<any> {
}

const EmployeeEditForm: React.FC<PropsInterface> = ({
  history
}) => {
  const employeeProfileStore = useContext(EmployeeProfileStore);
  const {
    clearEmployee,
    editEmployee,
    submitting,
    loadEmployeeProfile
  } = employeeProfileStore;
  const [employee, setEmployee] = useState<IEmployee>({
    email: "",
    name: "",
    preferredName: "",
    company: "",
    status: "",
    department: "",
    position: "",
    qualified: "",
    projectType: "",
    mobile: "",
    address: "",
    dob: "",
    startDate: "",
    companyEmail: "",
    workerId: "",
    type: "",
    australianResidency: "",
    nbnEnableId: "",
    usi: "",
    photoUrl: "",
    remark: "",
  });

  useEffect(() => {
    loadEmployeeProfile().then((employee) => setEmployee(employee));return () => {
      clearEmployee();
    };
  }, []);

  const typeOptions = [
    { key: "TFN", text: "TFN", value: "TFN" },
    { key: "ABN", text: "ABN", value: "ABN" },
    { key: "TFN+ABN", text: "TFN+ABN", value: "TFN+ABN" },
  ];

  const statusOptions = [
    { key: "Employee", text: "Employee", value: "Employee" },
    { key: "Subcontract", text: "Subcontract", value: "Subcontract" },
  ];
  const departOptions = [
    { key: "PMO", text: "PMO", value: "PMO" },
    { key: "IT&Cloud", text: "IT&Cloud", value: "IT&Cloud" },
    { key: "Technician", text: "Technician", value: "Technician" },
  ];

  const residencyOptions = [
    { key: "PR", text: "PR", value: "PR" },
    { key: "Citzen", text: "Citizen", value: "Citizen" },
    {
      key: "Temporary Working Visa(485)",
      text: "Temporary Working Visa(485)",
      value: "Temporary Working Visa(485)",
    },
    { key: "Student(500)", text: "Student(500)", value: "Student(500)" },
  ];

  const [residency, setResidency] = useState(residencyOptions);

  const handleSubmit = () => {
    editEmployee(employee).then(() => history.push('/employeeportal/profile'));
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setEmployee({ ...employee, [name]: value });
  };

  return (
    <Segment clearing >
      <Form onSubmit={handleSubmit}>
        <Form.Group widths="equal">
          <Form.Input
            label="Employee Name"
            readOnly
            disabled
            onChange={handleInputChange}
            name="name"
            placeholder="Employee Name"
            value={employee.name}
          />
          <Form.Input
            label="Preferred Name"
            onChange={handleInputChange}
            name="preferredName"
            placeholder="Employee Preferred Name"
            value={employee.preferredName}
          />
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Input
            label="Employee Email"
            readOnly
            disabled
            onChange={handleInputChange}
            name="email"
            placeholder="Employee Email"
            value={employee.email}
          />
          <Form.Input
          readOnly
          disabled
            label="Company Email"
            onChange={handleInputChange}
            name="companyEmail"
            placeholder="Company Email"
            value={employee.companyEmail}
          />
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Select
            label="Employement Status"
            disabled
            onChange={(e, { name, value }) =>
              setEmployee({ ...employee, [name]: value })
            }
            name="status"
            placeholder="Employee Status"
            value={employee.status}
            options={statusOptions}
            clearable
          />
          <Form.Select
            label="Department"
            disabled
            onChange={(e, { name, value }) =>
              setEmployee({ ...employee, [name]: value })
            }
            name="department"
            placeholder="Employee Department"
            value={employee.department}
            options={departOptions}
            clearable
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            label="Position"
            disabled
            onChange={handleInputChange}
            name="position"
            placeholder="Employee Position"
            value={employee.position}
          />
          <Form.Input
            label="Mobile"
            required
            onChange={handleInputChange}
            name="mobile"
            placeholder="Employee Mobile"
            value={employee.mobile}
          />
        </Form.Group>
        <Form.Input
          label="Address"
          required
          onChange={handleInputChange}
          name="address"
          placeholder="Employee Address"
          value={employee.address}
        />
        <Form.Group widths="equal">
          <Form.Input
            label="Date of Birth"
            required
            onChange={handleInputChange}
            name="dob"
            placeholder="Date of Birth"
            value={employee.dob}
            type="date"
          />
          <Form.Input
            label="Start Date"
            readOnly
            disabled
            onChange={handleInputChange}
            name="startDate"
            placeholder="Start Date"
            value={employee.startDate}
            type="date"
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Select
            label="Employee Type"
            onChange={(e, { name, value }) =>
              setEmployee({ ...employee, [name]: value })
            }
            name="type"
            placeholder="Employee Type"
            value={employee.type}
            options={typeOptions}
            clearable
            readOnly
            disabled
          />
          <Form.Select
          readOnly
          disabled
            label="Australian Residency"
            onChange={(e, { name, value }) =>
              setEmployee({ ...employee, [name]: value })
            }
            name="australianResidency"
            placeholder="Australian Residency"
            value={employee.australianResidency}
            options={residency}
            search
            selection
            fluid
            allowAdditions
            additionLabel="Add Residency type"
            onAddItem={(e, { value }) => {
              setResidency([
                {
                  key: value as string,
                  text: value as string,
                  value: value as string,
                },
                ...residency,
              ]);
            }}
          />
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Input
            label="Worker ID"
            onChange={handleInputChange}
            name="workerId"
            placeholder="Worker ID"
            value={employee.workerId}
          />
          <Form.Input
            label="NBN Enable ID"
            onChange={handleInputChange}
            name="nbnEnableId"
            placeholder="NBN Enable ID"
            value={employee.nbnEnableId}
          />
          <Form.Input
            label="USI"
            onChange={handleInputChange}
            name="usi"
            placeholder="USI"
            value={employee.usi}
          />
        </Form.Group>
        <Form.Input
          label="Remark"
          onChange={handleInputChange}
          name="remark"
          placeholder="Remark"
          value={employee.remark}
        />

        <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="submit"
        />
      </Form>
    </Segment>
  );
};

export default observer(EmployeeEditForm);
